import Swal from "sweetalert2";
import { SWAL_BASE, SWAL_CLASSES } from "@app/lib/swalClasses.js";
import { deleteAssistantChat } from "@app/store/assistantStore.svelte.js";
import * as m from "@app/paraglide/messages.js";

export async function confirmDeleteAssistantChat(chat) {
    if (!chat) return;
    const result = await Swal.fire({
        ...SWAL_BASE,
        customClass: SWAL_CLASSES.destructive,
        title: m.assistant_delete_chat_confirm_title(),
        text: m.assistant_delete_chat_confirm_text({ title: chat.title }),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: m.delete(),
        cancelButtonText: m.cancel(),
    });
    if (result.isConfirmed) {
        await deleteAssistantChat(chat.id);
    }
}
